module.exports = __webpack_public_path__ + "img/sw2.1b0a697f.svg";